import { useRef, useState } from "react";
import * as Icons from "react-icons/bs";
import { TWindowPosition, Themes } from "../../types";
import useDraggable from "../../hooks/useDraggable";
import '../../scss/lex-doc-rel.scss';
import '../../scss/vintage-controls.scss';

const NoSelectionModal = ({
  theme,
  onClose,
}: {
  theme: Themes,
  onClose: () => void,
}) => {
  const [position, setPosition] = useState<TWindowPosition>({ x: 0, y: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const windowRef = useRef<HTMLDivElement>(null);

  const { isDragging, handleMouseDown } = useDraggable({
    initialPosition: position,
    containerRef,
    elementRef: windowRef,
    onPositionChange: (p) => setPosition(p),
    autoAlignToMiddle: true,
  });

  return (
    <div className="full-screen-modal" ref={containerRef}>
      <div
        className={`virtual-window advanced-search-container  ${isDragging ? "dragging" : ""} ${theme}`}
        ref={windowRef}
        style={{
          position: "absolute",
          top: `${position.y}px`,
          left: `${position.x}px`,
          height: '8.5rem',
          width: '25rem',
        }}
      >
        <div className="window-header" onMouseDown={handleMouseDown}>
          <div className="window-title">
            <i className="file-icon">
              <Icons.BsPrinterFill />
            </i>
            <span>Tiparire selectie</span>
          </div>
          <div className="window-controls">
            <button
              className="window-control close"
              onClick={onClose}
            >
              ✕
            </button>
          </div>
        </div>
        <div className="window-content d-flex flex-row align-items-center w-100 justify-content-center" style={{ gap: '0.5rem' }}>
          <Icons.BsExclamationTriangleFill />
          Nu este selectat niciun text
        </div>
        <div className="window-footer" style={{ justifyContent: 'center' }}>
          <button className="advanced-search-button" style={{ marginLeft: 'auto', marginRight: 'unset' }} onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  )
}

export default NoSelectionModal;
